<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/anbzSE/tc-custom/9781504047401.jpg?1701231169683" alt="This image is the cover for the book Budayeen Cycle, The Budayeen Cycle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Budayeen Cycle, The Budayeen Cycle
      </h1>
      <p class="bookDescription body article font2">
        <b>The complete Hugo and Nebula Award–nominated cyberpunk trilogy by an author whose work is “wry and black and savage” (George R. R. Martin). </b><br/><br/> Praised as “a perfect example of how exciting the subgenre can and should be,” George Alec Effinger’s Budayeen Cycle is a towering and timeless science fiction achievement that continues to amaze, shock, and captivate readers (<i>SF Signal</i>).<br/>  <br/><i>When Gravity Fails</i>: Set in a high-tech near future featuring an ascendant Muslim world and divided Western superpowers, this cult classic takes readers into a world with mind- or mood-altering drugs for any purpose, brains enhanced by electronic hardware, and surgically altered bodies. Street hustler Marîd Audran has always prided himself on his independence, free from commitments, connections, and even cybernetic modifications. But when a string of brutal murders lands him on the radar of Friedlander Bey, the most powerful and dangerous man in the decadent Arab ghetto, the Budayeen, Audran is forced to change his loner ways, or risk losing his life . . .<br/>  <br/><i>A Fire in the Sun</i>: Once a small-time smuggler, Marîd Audran has, to his chagrin, moved up in the ranks of the criminal underworld to become a lieutenant in Friedlander Bey’s shadowy empire. Tasked with being Bey’s eyes and ears inside local law enforcement, Audran finds himself tracking yet another serial killer through the streets of the Budayeen. And the closer he gets to his target, the more embroiled he becomes in the deadly political machinations hidden behind the city’s façade.<br/>  <br/><i>The Exile Kiss</i>: Marîd Audran is finally learning to appreciate the wealth and benefits that come from being on Friedlander Bey’s payroll when a powerful enemy does the unthinkable, and gets both Audran and Bey exiled from the Budayeen. Abandoned in the lifeless and lethal Arabian Desert, Audran and Bey have only one option: survive long enough to exact revenge on the man responsible.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Alec Effinger
      </h2>
      
      <p class="authorDescription body article">George A. Effinger was born in Cleveland, Ohio, in 1947. He attended Yale University, where an organic chemistry course disabused him of the notion of becoming a doctor. He had the opportunity to meet many of his science fiction idols thanks to his first wife, who was Damon Knight and Kate Wilhelm&rsquo;s babysitter. With their encouragement, he began writing science fiction in 1970. He published at least twenty novels and six collections of short fiction, including <I>When Gravity Fails</I> and <I>The Exile Kiss</I>. He also wrote and published two crime novels, <I>Felicia</I> and <I>Shadow Money</I>. With his Budayeen novels, Effinger helped to found the cyberpunk genre. He was a Hugo and Nebula Award winner and is a favorite among fellow science fiction writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3985f0d9